app.controller('popupBusinessIntelligenceUploadFileController', ['$scope', '$state', '$mdDialog', 'baseOfCaseModel',
    function ($scope, $state, $mdDialog, baseOfCaseModel) {

        function setData() {
            $scope.Enum = Enum;
            $scope.isUploading = false;
        }

        function setPermissions() {
        }

        function setListeners() {
            $scope.$on(Event.BASE_OF_CASE.UPLOAD_FILE.SUCCESS, function(event, result) {
                $mdDialog.hide(result);
            });
        }

        function setActions() {
            $scope.cancel = function() {
                $mdDialog.cancel();
            };

            $scope.enclose = function (fileInput) {
                if (fileInput.length > 0) {
                    baseOfCaseModel.uploadFile(fileInput[0]);
                    $scope.isUploading = true;
                } else {
                    $scope.isUploading = false;
                }
            };
        }

        function configureInterface() {

        }

        function initialize() {

        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);